function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getMarketCode } from "../utils/get-market-code";
import { trackedAlgoliaIndexFields } from "./algolia-search-index";
import { isInAppWebview } from "./in-app-webview";
import { isOrderConfirmationPage } from "./is-order-confirmation-page";
import { formatPaymentMethodLabel } from "./payment-method-label";
import { toE164Digits } from "./phone-match";
import { buildItemProductUrl, getStorefrontHostForItem } from "./storefront-redirect";

// Window.analytics is declared in src/types.ts
var trackingEventNames = ["Cart Identified", "Checkout Started", "Checkout Step Viewed", "Checkout Step Completed", "Payment Info Entered", "Order Completed", "Coupon Entered",
// NOT USED
"Coupon Applied", "Coupon Denied",
// NOT USED
"Gift Card Entered",
// NOT USED
"Gift Card Applied", "Gift Card Denied",
// NOT USED
"Coupon / Gift Card Entered", "Coupon / Gift Card Applied",
// NOT USED
"Coupon / Gift Card Denied", "First Order Completed", "First Whisky Order Completed", "Whisky Order Completed", "Add New Address", "Add New Address - Success", "Add New Address - Failed", "Edit Profile Address", "Edit Profile Address - Success", "Edit Profile Address - Failed", "Edit Shipping/Billing/Consignment Address", "Edit Shipping/Billing/Consignment Address - Success", "Edit Shipping/Billing/Consignment Address - Failed", "Ship To This Address", "Ship To This Address - Success", "Ship To This Address - Failed", "Delete This Address", "Delete This Address - Success", "Delete This Address - Failed", "Address Verification Modal Triggered", "Address Selected From Verification Modal", "Last-Used Address Incomplete", "Address Edit During Card Entry", "Continue To Payment", "Create an Account Clicked", "Back to Store", "Payment Failed", "Wallet Rejection Detail", "Wallet Scope Recovery", "Google Pay Funnel", "Secret Cellar Banner Clicked", "Secret Cellar Banner Viewed", "Guest email submitted", "Edit Shipping - Started", "Edit Shipping - Success", "Edit Shipping - Failed"];
export var EventType = /*#__PURE__*/function (EventType) {
  EventType["Click"] = "click";
  EventType["View"] = "view";
  EventType["Conversion"] = "conversion";
  return EventType;
}({});
export var EventSubType = /*#__PURE__*/function (EventSubType) {
  EventSubType["AddToCart"] = "addToCart";
  EventSubType["Purchase"] = "purchase";
  return EventSubType;
}({});
var marketCode = getMarketCode();

/**
 * True only when Segment's snippet stubbed `window.analytics` AND the
 * build shipped a non-empty `_writeKey`. Gate one-shot side effects
 * (e.g. the `?order-tracked=true` URL stamp) so a misconfigured deploy
 * stays recoverable on refresh once the key is restored.
 */
export var isAnalyticsLive = function isAnalyticsLive() {
  if (typeof window === "undefined") return false;
  var a = window.analytics;
  return typeof (a === null || a === void 0 ? void 0 : a._writeKey) === "string" && a._writeKey.length > 0;
};
export var trackSecretCellarEvent = function trackSecretCellarEvent(eventName, order, skus, cellarPath) {
  var data = {
    orderId: order === null || order === void 0 ? void 0 : order.orderId,
    createdAt: order === null || order === void 0 ? void 0 : order.createdAt,
    skus: skus,
    eventPath: cellarPath
  };
  if (typeof window !== "undefined" && window.analytics) {
    window.analytics.track(eventName, data);
  }
};

// Pairs with the storefronts' "Cart Identified": both sides key on the
// BigCommerce cart id so a whiskymofo.com / vinomofo.com session can be
// stitched to this checkout session even when cookies don't cross domains.
export var trackCartIdentified = function trackCartIdentified(cartId) {
  if (!cartId) return;
  if (typeof window !== "undefined" && window.analytics) {
    window.analytics.track("Cart Identified", {
      cart_id: cartId
    });
  }
};

// Tags address events with their originating surface so analytics can split
// otherwise-identical events fired from both checkout and order-confirmation.

export var getTrackingLocation = function getTrackingLocation() {
  return isOrderConfirmationPage() ? "order-confirmation" : "checkout";
};
export var trackUserActionOnAddress = function trackUserActionOnAddress(eventName, address, checkoutId, is_oneline_address) {
  var data = {
    checkout_id: checkoutId,
    address: address,
    is_oneline_address: is_oneline_address,
    location: getTrackingLocation()
  };
  if (typeof window !== "undefined" && window.analytics) {
    window.analytics.track(eventName, data);
  }
};
export var trackAddressVerificationModal = function trackAddressVerificationModal(eventName, data) {
  if (typeof window !== "undefined" && window.analytics) {
    window.analytics.track(eventName, _objectSpread(_objectSpread({}, data), {}, {
      location: getTrackingLocation()
    }));
  }
};
var EDIT_SHIPPING_EVENT_NAME = {
  started: "Edit Shipping - Started",
  success: "Edit Shipping - Success",
  failed: "Edit Shipping - Failed"
};
// Single readable line (unit → street → suburb → state → postcode → country)
// so the previous/new addresses are legible side-by-side in the analytics event.
var formatTrackedAddress = function formatTrackedAddress(a) {
  return !a ? "" : [[a.firstName, a.lastName].filter(Boolean).join(" "), a.company, a.address2, a.address1, a.city, a.stateOrProvince || a.stateOrProvinceCode, a.postalCode, a.country].filter(Boolean).join(", ");
};
export var trackEditShipping = function trackEditShipping(status, data) {
  if (typeof window === "undefined" || !window.analytics) return;
  window.analytics.track(EDIT_SHIPPING_EVENT_NAME[status], _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    order_id: data.orderId,
    cart_id: data.cartId,
    is_guest: data.isGuest,
    source: data.source,
    location: getTrackingLocation()
  }, data.currentAddress !== undefined ? {
    current_address: formatTrackedAddress(data.currentAddress)
  } : {}), data.previousAddress !== undefined ? {
    previous_address: formatTrackedAddress(data.previousAddress)
  } : {}), data.newAddress ? {
    new_address: formatTrackedAddress(data.newAddress)
  } : {}), data.reason ? {
    reason: data.reason
  } : {}));
};

// Fired once per checkout session when a logged-in shopper's restored
// last-used address is flagged invalid (missing/invalid phone, missing
// required custom field, blank core field) and they're pushed into
// editing. `lastOrderPaymentMethod` carries the method that established
// that address — express wallets (Apple/Google Pay, PayPal) write
// phone-less / custom-field-less addresses, so this quantifies which
// method is the biggest source of the friction.
export var trackLastUsedAddressIncomplete = function trackLastUsedAddressIncomplete(data) {
  var _data$lastOrderPaymen;
  if (typeof window === "undefined" || !window.analytics) return;
  window.analytics.track("Last-Used Address Incomplete", {
    checkout_id: data.checkoutId,
    cart_id: data.cartId,
    invalid_address: formatTrackedAddress(data.invalidAddress),
    invalid_phone: data.invalidPhone,
    has_phone: data.hasPhone,
    phone_valid: data.phoneValid,
    reasons: data.reasons,
    missing_custom_fields: data.missingCustomFields,
    last_order_payment_method: (_data$lastOrderPaymen = data.lastOrderPaymentMethod) !== null && _data$lastOrderPaymen !== void 0 ? _data$lastOrderPaymen : "unknown",
    last_order_id: data.lastOrderId,
    last_order_date: data.lastOrderDate,
    last_order_address: data.lastOrderAddress,
    last_order_phone: data.lastOrderPhone,
    location: getTrackingLocation()
  });
};
/**
 * Beacons the card-entry / address-edit collision, which used to lose the
 * shopper their card and their Pay button silently. Both stages are rare by
 * nature -- only a detour mid-entry reaches them -- so the counts are the
 * production check on the guards: `pane_kept_open` going false, or
 * `form_preserved` drying up, means one of them has moved.
 *
 * `card_started` is what separates a real save from a no-op: a mounted form
 * the shopper never touched is worth nothing to preserve.
 */
export var trackAddressEditDuringCardEntry = function trackAddressEditDuringCardEntry(data, stage, detail) {
  var _checkout$cart;
  if (typeof window === "undefined" || !window.analytics || !data) return;
  var checkout = function () {
    try {
      return data.getCheckout();
    } catch (_unused) {
      return undefined;
    }
  }();
  var customer = function () {
    try {
      return data.getCustomer();
    } catch (_unused2) {
      return undefined;
    }
  }();
  window.analytics.track("Address Edit During Card Entry", _objectSpread(_objectSpread({
    checkout_id: checkout === null || checkout === void 0 ? void 0 : checkout.id,
    cart_id: checkout === null || checkout === void 0 || (_checkout$cart = checkout.cart) === null || _checkout$cart === void 0 ? void 0 : _checkout$cart.id,
    market: marketCode,
    stage: stage,
    // Guests reach `form_preserved` too -- correcting their address after the
    // form mounts -- so the two populations need separating.
    is_guest: customer === null || customer === void 0 ? void 0 : customer.isGuest,
    card_started: detail.cardStarted,
    card_complete: detail.cardComplete
  }, detail.paneKeptOpen !== undefined ? {
    pane_kept_open: detail.paneKeptOpen
  } : {}), {}, {
    location: getTrackingLocation()
  }));
};
export var trackBackToStoreEvent = function trackBackToStoreEvent(eventName, cart, checkout, onFlush) {
  var _cart$lineItems, _cart$lineItems2;
  var discount = checkout.discounts ? checkout.discounts.reduce(function (a, b) {
    return a + b.discountedAmount;
  }, 0) : 0;
  var physicalItems = cart === null || cart === void 0 || (_cart$lineItems = cart.lineItems) === null || _cart$lineItems === void 0 ? void 0 : _cart$lineItems.physicalItems.map(function (item) {
    return lineItemToSegmentProduct(item);
  });
  var digitalItems = cart === null || cart === void 0 || (_cart$lineItems2 = cart.lineItems) === null || _cart$lineItems2 === void 0 ? void 0 : _cart$lineItems2.digitalItems.map(function (item) {
    return lineItemToSegmentProduct(item);
  });
  var productList = [].concat(_toConsumableArray(physicalItems), _toConsumableArray(digitalItems));
  var data = {
    cart_id: cart === null || cart === void 0 ? void 0 : cart.id,
    customer_group: cart === null || cart === void 0 ? void 0 : cart.customer_group,
    value: checkout === null || checkout === void 0 ? void 0 : checkout.subtotal,
    revenue: checkout === null || checkout === void 0 ? void 0 : checkout.subtotal,
    shipping: checkout === null || checkout === void 0 ? void 0 : checkout.shippingCostTotal,
    tax: checkout === null || checkout === void 0 ? void 0 : checkout.taxTotal,
    discount: discount,
    coupon: null,
    currency: cart === null || cart === void 0 ? void 0 : cart.currency.code,
    guest_checkout: cart.guest_checkout,
    first_purchase: cart.first_purchase,
    products: productList
  };
  if (typeof window !== "undefined" && window.analytics) {
    window.analytics.track(eventName, data, undefined, onFlush);
    return;
  }
  onFlush === null || onFlush === void 0 || onFlush();
};
export var trackViewCheckoutEvent = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(eventName, cart, checkout) {
    var _checkout$consignment, _checkout$consignment2, _cart$lineItems3, _cart$lineItems4, _checkout$consignment3, _checkout$consignment4, _checkout$consignment5, _checkout$consignment6, _checkout$consignment7, _checkout$consignment8;
    var discount, fullName, physicalItems, digitalItems, productList, data;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          discount = checkout.discounts ? checkout.discounts.reduce(function (a, b) {
            return a + b.discountedAmount;
          }, 0) : 0;
          fullName = "".concat(checkout === null || checkout === void 0 || (_checkout$consignment = checkout.consignments) === null || _checkout$consignment === void 0 || (_checkout$consignment = _checkout$consignment[0]) === null || _checkout$consignment === void 0 || (_checkout$consignment = _checkout$consignment.shippingAddress) === null || _checkout$consignment === void 0 ? void 0 : _checkout$consignment.firstName, " ").concat(checkout === null || checkout === void 0 || (_checkout$consignment2 = checkout.consignments) === null || _checkout$consignment2 === void 0 || (_checkout$consignment2 = _checkout$consignment2[0]) === null || _checkout$consignment2 === void 0 || (_checkout$consignment2 = _checkout$consignment2.shippingAddress) === null || _checkout$consignment2 === void 0 ? void 0 : _checkout$consignment2.lastName);
          physicalItems = cart === null || cart === void 0 || (_cart$lineItems3 = cart.lineItems) === null || _cart$lineItems3 === void 0 ? void 0 : _cart$lineItems3.physicalItems.map(lineItemToSegmentProduct);
          digitalItems = cart === null || cart === void 0 || (_cart$lineItems4 = cart.lineItems) === null || _cart$lineItems4 === void 0 ? void 0 : _cart$lineItems4.digitalItems.map(lineItemToSegmentProduct);
          productList = [].concat(_toConsumableArray(physicalItems), _toConsumableArray(digitalItems));
          data = {
            cart_id: cart === null || cart === void 0 ? void 0 : cart.id,
            customer_group: cart === null || cart === void 0 ? void 0 : cart.customer_group,
            value: checkout === null || checkout === void 0 ? void 0 : checkout.subtotal,
            revenue: checkout === null || checkout === void 0 ? void 0 : checkout.subtotal,
            shipping: checkout === null || checkout === void 0 ? void 0 : checkout.shippingCostTotal,
            state: marketCode === "AU" && fullName !== "Mofo User" ? (_checkout$consignment3 = checkout === null || checkout === void 0 || (_checkout$consignment4 = checkout.consignments) === null || _checkout$consignment4 === void 0 || (_checkout$consignment4 = _checkout$consignment4[0]) === null || _checkout$consignment4 === void 0 || (_checkout$consignment4 = _checkout$consignment4.shippingAddress) === null || _checkout$consignment4 === void 0 ? void 0 : _checkout$consignment4.stateOrProvince) !== null && _checkout$consignment3 !== void 0 ? _checkout$consignment3 : "" : undefined,
            state_code: marketCode === "AU" && fullName !== "Mofo User" ? (_checkout$consignment5 = checkout === null || checkout === void 0 || (_checkout$consignment6 = checkout.consignments) === null || _checkout$consignment6 === void 0 || (_checkout$consignment6 = _checkout$consignment6[0]) === null || _checkout$consignment6 === void 0 || (_checkout$consignment6 = _checkout$consignment6.shippingAddress) === null || _checkout$consignment6 === void 0 ? void 0 : _checkout$consignment6.stateOrProvinceCode) !== null && _checkout$consignment5 !== void 0 ? _checkout$consignment5 : "" : undefined,
            postcode: marketCode === "AU" && fullName !== "Mofo User" ? (_checkout$consignment7 = checkout === null || checkout === void 0 || (_checkout$consignment8 = checkout.consignments) === null || _checkout$consignment8 === void 0 || (_checkout$consignment8 = _checkout$consignment8[0]) === null || _checkout$consignment8 === void 0 || (_checkout$consignment8 = _checkout$consignment8.shippingAddress) === null || _checkout$consignment8 === void 0 ? void 0 : _checkout$consignment8.postalCode) !== null && _checkout$consignment7 !== void 0 ? _checkout$consignment7 : "" : undefined,
            tax: checkout === null || checkout === void 0 ? void 0 : checkout.taxTotal,
            discount: discount,
            coupon: null,
            currency: cart === null || cart === void 0 ? void 0 : cart.currency.code,
            guest_checkout: cart.guest_checkout,
            first_purchase: cart.first_purchase,
            products: productList
          };
          if (!(typeof window !== "undefined" && window.analytics)) {
            _context.n = 1;
            break;
          }
          window.analytics.track(eventName, data);
          return _context.a(2, true);
        case 1:
          return _context.a(2, false);
      }
    }, _callee);
  }));
  return function trackViewCheckoutEvent(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

// Funnel dispatch queue. The centralised effect in Checkout.tsx can fire
// V1 → C1 → V2 → C2 inside a single JS tick, which makes all four
// analytics.track() calls share a millisecond. Segment's debugger then
// orders them by server-side `receivedAt` and falls back to an alphabetical
// tiebreaker ("Completed" < "Viewed"), so the displayed sequence becomes
// V, V, C, C instead of V, C, V, C. Routing funnel fires through a FIFO
// queue with a small gap also separates them on the wire so `receivedAt`
// preserves the intended order. Pair this with `monotonicFunnelTimestamp`
// so destinations that key off the client `timestamp` see the same order.
var FUNNEL_DISPATCH_GAP_MS = 25;
var funnelQueue = [];
var funnelDispatching = false;
var _dispatchNextFunnelEvent = function dispatchNextFunnelEvent() {
  var fire = funnelQueue.shift();
  if (!fire) {
    funnelDispatching = false;
    return;
  }
  fire();
  setTimeout(_dispatchNextFunnelEvent, FUNNEL_DISPATCH_GAP_MS);
};
var enqueueFunnelEvent = function enqueueFunnelEvent(fire) {
  funnelQueue.push(fire);
  if (funnelDispatching) return;
  funnelDispatching = true;
  _dispatchNextFunnelEvent();
};
var lastFunnelTimestampMs = 0;
var monotonicFunnelTimestamp = function monotonicFunnelTimestamp() {
  var ts = Math.max(Date.now(), lastFunnelTimestampMs + 1);
  lastFunnelTimestampMs = ts;
  return new Date(ts);
};

// Funnel C2 one-shot gate. C2 ("Checkout Step Completed", step 2) fires
// from Payment.tsx's success paths (right before navigateToOrderConfirmation)
// so the event reflects an outcome -- the gateway accepted the payment --
// matching v1's semantic. Checkout.tsx owns V1/C1/V2; this module-level
// flag bridges them so multiple success branches (standard submitOrder,
// hosted-instrument API-payment, Stripe pending-PI recovery) can't
// double-fire C2. Reset by Checkout.tsx on mount so a fresh checkout
// session starts clean.
var funnelStep2Completed = false;
export var wasFunnelStep2Completed = function wasFunnelStep2Completed() {
  return funnelStep2Completed;
};
export var markFunnelStep2Completed = function markFunnelStep2Completed() {
  funnelStep2Completed = true;
};
export var resetFunnelStep2 = function resetFunnelStep2() {
  funnelStep2Completed = false;
};
export var trackCheckoutStepViewedEvent = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(eventName, stepNumber, checkoutId) {
    var data;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          data = {
            checkout_id: checkoutId,
            step: stepNumber
          };
          if (typeof window !== "undefined" && window.analytics) {
            enqueueFunnelEvent(function () {
              var _window$analytics;
              (_window$analytics = window.analytics) === null || _window$analytics === void 0 || _window$analytics.track(eventName, data, {
                timestamp: monotonicFunnelTimestamp()
              });
            });
          }
          return _context2.a(2, true);
      }
    }, _callee2);
  }));
  return function trackCheckoutStepViewedEvent(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
export var trackCheckoutStepCompletedEvent = function trackCheckoutStepCompletedEvent(eventName, stepNumber, checkoutId, checkout, isfirstPurchase) {
  var _checkout$consignment9, _checkout$consignment0, _checkout$consignment1, _checkout$consignment10, _checkout$consignment11, _checkout$consignment12, _checkout$consignment13, _checkout$consignment14, _checkout$customer;
  var fullName = "".concat(checkout === null || checkout === void 0 || (_checkout$consignment9 = checkout.consignments) === null || _checkout$consignment9 === void 0 || (_checkout$consignment9 = _checkout$consignment9[0]) === null || _checkout$consignment9 === void 0 || (_checkout$consignment9 = _checkout$consignment9.shippingAddress) === null || _checkout$consignment9 === void 0 ? void 0 : _checkout$consignment9.firstName, " ").concat(checkout === null || checkout === void 0 || (_checkout$consignment0 = checkout.consignments) === null || _checkout$consignment0 === void 0 || (_checkout$consignment0 = _checkout$consignment0[0]) === null || _checkout$consignment0 === void 0 || (_checkout$consignment0 = _checkout$consignment0.shippingAddress) === null || _checkout$consignment0 === void 0 ? void 0 : _checkout$consignment0.lastName);
  var data = {
    checkout_id: checkoutId,
    step: stepNumber,
    state: marketCode === "AU" && fullName !== "Mofo User" ? (_checkout$consignment1 = checkout === null || checkout === void 0 || (_checkout$consignment10 = checkout.consignments) === null || _checkout$consignment10 === void 0 || (_checkout$consignment10 = _checkout$consignment10[0]) === null || _checkout$consignment10 === void 0 || (_checkout$consignment10 = _checkout$consignment10.shippingAddress) === null || _checkout$consignment10 === void 0 ? void 0 : _checkout$consignment10.stateOrProvince) !== null && _checkout$consignment1 !== void 0 ? _checkout$consignment1 : "" : undefined,
    state_code: marketCode === "AU" && fullName !== "Mofo User" ? (_checkout$consignment11 = checkout === null || checkout === void 0 || (_checkout$consignment12 = checkout.consignments) === null || _checkout$consignment12 === void 0 || (_checkout$consignment12 = _checkout$consignment12[0]) === null || _checkout$consignment12 === void 0 || (_checkout$consignment12 = _checkout$consignment12.shippingAddress) === null || _checkout$consignment12 === void 0 ? void 0 : _checkout$consignment12.stateOrProvinceCode) !== null && _checkout$consignment11 !== void 0 ? _checkout$consignment11 : "" : undefined,
    postcode: marketCode === "AU" && fullName !== "Mofo User" ? (_checkout$consignment13 = checkout === null || checkout === void 0 || (_checkout$consignment14 = checkout.consignments) === null || _checkout$consignment14 === void 0 || (_checkout$consignment14 = _checkout$consignment14[0]) === null || _checkout$consignment14 === void 0 || (_checkout$consignment14 = _checkout$consignment14.shippingAddress) === null || _checkout$consignment14 === void 0 ? void 0 : _checkout$consignment14.postalCode) !== null && _checkout$consignment13 !== void 0 ? _checkout$consignment13 : "" : undefined,
    guest_checkout: checkout === null || checkout === void 0 || (_checkout$customer = checkout.customer) === null || _checkout$customer === void 0 ? void 0 : _checkout$customer.isGuest,
    first_purchase: isfirstPurchase
  };
  if (typeof window !== "undefined" && window.analytics) {
    enqueueFunnelEvent(function () {
      var _window$analytics2;
      (_window$analytics2 = window.analytics) === null || _window$analytics2 === void 0 || _window$analytics2.track(eventName, data, {
        timestamp: monotonicFunnelTimestamp()
      });
    });
  }
};
export var trackPaymentInfoEntered = function trackPaymentInfoEntered(eventName, stepNumber, data, paymentMethod) {
  var _data$getSelectedShip;
  var checkoutId = data === null || data === void 0 ? void 0 : data.getCheckout().id;
  var shippingMethod = data === null || data === void 0 || (_data$getSelectedShip = data.getSelectedShippingOption()) === null || _data$getSelectedShip === void 0 ? void 0 : _data$getSelectedShip.description;
  var analyticData = {
    checkout_id: checkoutId,
    step: stepNumber,
    payment_method: formatPaymentMethodLabel(paymentMethod),
    shipping_method: shippingMethod
  };
  if (typeof window !== "undefined" && window.analytics) {
    window.analytics.track(eventName, analyticData);
  }
};
export var trackPaymentFailed = function trackPaymentFailed(eventName, data, paymentMethod, errorMsg) {
  var _data$getSelectedShip2;
  var checkoutId = data === null || data === void 0 ? void 0 : data.getCheckout().id;
  var shippingMethod = data === null || data === void 0 || (_data$getSelectedShip2 = data.getSelectedShippingOption()) === null || _data$getSelectedShip2 === void 0 ? void 0 : _data$getSelectedShip2.description;
  var analyticData = {
    checkout_id: checkoutId,
    payment_method: formatPaymentMethodLabel(paymentMethod),
    shipping_method: shippingMethod,
    error_message: errorMsg
  };
  if (typeof window !== "undefined" && window.analytics) {
    window.analytics.track(eventName, analyticData);
  }
};

/**
 * Beacon the *underlying* detail of a wallet failure.
 *
 * BigCommerce's Google Pay strategy hands our `onError` only a generic
 * "An error occurred while requesting your Google Pay payment details." string,
 * but rethrows the real error (`new Error(JSON.stringify(googlePayError))`) from
 * its click listener -- which surfaces as an `unhandledrejection`. That object
 * is created in the first-party checkout bundle, so its message carries the true
 * `statusCode` / `statusMessage`, unlike the cross-origin-masked "Script error."
 * that `window.onerror` receives. This is a DISTINCT event from "Payment Failed"
 * on purpose, so surfacing the detail doesn't double-count the funnel metric.
 */
export var trackWalletRejectionDetail = function trackWalletRejectionDetail(data, errorMsg) {
  var checkoutId;
  try {
    var _data$getCheckout;
    checkoutId = data === null || data === void 0 || (_data$getCheckout = data.getCheckout()) === null || _data$getCheckout === void 0 ? void 0 : _data$getCheckout.id;
  } catch (_unused3) {
    checkoutId = undefined;
  }
  var analyticData = {
    checkout_id: checkoutId,
    error_message: errorMsg
  };
  if (typeof window !== "undefined" && window.analytics) {
    window.analytics.track("Wallet Rejection Detail", analyticData);
  }
};
var isAfterpayId = function isAfterpayId(id) {
  return id.includes("afterpay") || id.includes("clearpay");
};

// Which collapsed wallet list triggered recovery:
// - `paypal_scope`: PayPal + Card only, Google Pay gone (stale PayPal
//   remote-checkout scope). Confirmed mechanism.
// - `gpay_cancel`: Google Pay + Card only, PayPal gone -- the state shoppers
//   land in after repeated Google Pay cancels. Unconfirmed; the `recovered`
//   flag is what tells us whether forget-checkout actually clears it.

/**
 * Beacon a wallet-scope recovery attempt. Fires when the payment step loads
 * collapsed to a single-wallet + Card state and `useWalletScopeRecovery` runs
 * `forget-checkout` + reload. Covers both signatures (`paypal_scope`,
 * `gpay_cancel`). Captures the signature *and the outcome* (did forget succeed,
 * did the missing wallet return) so we get production proof the fix takes for
 * each -- and can tell whether forget-checkout is even the right lever for the
 * unconfirmed GPay case -- instead of shipping it blind.
 */
export var trackWalletScopeRecovery = function trackWalletScopeRecovery(data, outcome) {
  var _checkout$cart2, _customer$storeCredit;
  if (typeof window === "undefined" || !window.analytics || !data) return;
  var checkout = function () {
    try {
      return data.getCheckout();
    } catch (_unused4) {
      return undefined;
    }
  }();
  var customer = function () {
    try {
      return data.getCustomer();
    } catch (_unused5) {
      return undefined;
    }
  }();
  var analyticData = {
    checkout_id: checkout === null || checkout === void 0 ? void 0 : checkout.id,
    cart_id: checkout === null || checkout === void 0 || (_checkout$cart2 = checkout.cart) === null || _checkout$cart2 === void 0 ? void 0 : _checkout$cart2.id,
    market: marketCode,
    signature: outcome.signature,
    is_guest: customer === null || customer === void 0 ? void 0 : customer.isGuest,
    has_store_credit: ((_customer$storeCredit = customer === null || customer === void 0 ? void 0 : customer.storeCredit) !== null && _customer$storeCredit !== void 0 ? _customer$storeCredit : 0) > 0,
    grand_total: checkout === null || checkout === void 0 ? void 0 : checkout.grandTotal,
    forgot: outcome.forgot,
    recovered: outcome.recovered,
    // In-app webviews (FB/IG) correlate with the GPay-cancel case -- their
    // isolated cookie jar sends the sheet to a Google login wall.
    in_app_webview: isInAppWebview(),
    // Prime suspect that scoped the cart: a pending remote provider.
    pending_payments: ((checkout === null || checkout === void 0 ? void 0 : checkout.payments) || []).map(function (p) {
      return p.providerId || p.gatewayId;
    }).filter(Boolean).join(","),
    method_ids_after: outcome.methodIdsAfter.join(","),
    has_afterpay_after: outcome.methodIdsAfter.some(function (id) {
      return isAfterpayId(id);
    }),
    location: getTrackingLocation()
  };
  window.analytics.track("Wallet Scope Recovery", analyticData);
};

// Step-by-step Google Pay *express* funnel. v1 GPay is a final payment method
// on an already-valid order, so it only ever submits; v2 GPay is an express
// button that must rebuild the order (address/shipping/phone) from the wallet
// after the sheet closes. That gives v2 several drop-off points v1 can't have.
// A plain "Payment Failed" can't tell a benign sheet-dismiss from a country
// block from a real decline, so this event tags each stage to locate exactly
// where express taps are lost.
//
// `card_selected` is the denominator that matches v1's "deliberate attempt"
// (the shopper committed a card in the sheet); `sheet_requested` -
// `card_selected` is the exploratory-tap drop-off v1 never counted.

// engagement went idle with no card selected (cancel)

export var trackGooglepayFunnel = function trackGooglepayFunnel(data, stage, detail) {
  // Selectors can throw before hydration; a diagnostic must never break the
  // pay flow.
  var checkoutId;
  var isGuest;
  try {
    var _data$getCheckout2, _data$getCustomer;
    checkoutId = data === null || data === void 0 || (_data$getCheckout2 = data.getCheckout()) === null || _data$getCheckout2 === void 0 ? void 0 : _data$getCheckout2.id;
    isGuest = data === null || data === void 0 || (_data$getCustomer = data.getCustomer()) === null || _data$getCustomer === void 0 ? void 0 : _data$getCustomer.isGuest;
  } catch (_unused6) {
    checkoutId = undefined;
  }
  var analyticData = {
    checkout_id: checkoutId,
    stage: stage,
    guest_checkout: isGuest,
    error_message: detail === null || detail === void 0 ? void 0 : detail.message,
    status_code: detail === null || detail === void 0 ? void 0 : detail.statusCode,
    ms_since_tap: detail === null || detail === void 0 ? void 0 : detail.msSinceTap
  };
  if (typeof window !== "undefined" && window.analytics) {
    // Ordered dispatch so Segment keeps card_selected -> submit_* sequence.
    enqueueFunnelEvent(function () {
      var _window$analytics3;
      (_window$analytics3 = window.analytics) === null || _window$analytics3 === void 0 || _window$analytics3.track("Google Pay Funnel", analyticData, {
        timestamp: monotonicFunnelTimestamp()
      });
    });
  }
};
export var trackOrderCompleted = function trackOrderCompleted(eventName, data) {
  var paymentMethod = data.paymentMethod,
    shippingMethod = data.shippingMethod,
    lineItems = data.lineItems,
    orderId = data.orderId,
    billingAddress = data.billingAddress,
    baseAmount = data.baseAmount,
    shippingCostTotal = data.shippingCostTotal,
    taxTotal = data.taxTotal,
    discountAmount = data.discountAmount,
    coupons = data.coupons,
    currency = data.currency,
    firstOrder = data.firstOrder,
    isDealer = data.isDealer,
    channel = data.channel,
    agent = data.agent,
    checkoutMode = data.checkoutMode,
    cartId = data.cartId,
    opt_in = data.opt_in,
    customerGroup = data.customerGroup;
  var mapAddress = function mapAddress(address) {
    return {
      firstName: address === null || address === void 0 ? void 0 : address.firstName,
      lastName: address === null || address === void 0 ? void 0 : address.lastName,
      email: address === null || address === void 0 ? void 0 : address.email,
      // Phone is a first-class identity match key downstream (Meta CAPI, Klaviyo,
      // HubSpot); this whitelist silently dropped it even though the order
      // transformer populates `billingAddress.phone`. Normalised to E.164
      // digits because the CAPI hash is unmatchable otherwise — see toE164Digits.
      phone: toE164Digits(address === null || address === void 0 ? void 0 : address.phone) || undefined,
      city: address === null || address === void 0 ? void 0 : address.city,
      state: address === null || address === void 0 ? void 0 : address.stateOrProvince,
      postalCode: address === null || address === void 0 ? void 0 : address.postalCode,
      country: address === null || address === void 0 ? void 0 : address.country
    };
  };
  var physicalItems = lineItems === null || lineItems === void 0 ? void 0 : lineItems.physicalItems.map(function (item) {
    return lineItemToSegmentProduct(item);
  });
  var digitalItems = lineItems === null || lineItems === void 0 ? void 0 : lineItems.digitalItems.map(function (item) {
    return lineItemToSegmentProduct(item);
  });
  var productList = [].concat(_toConsumableArray(physicalItems), _toConsumableArray(digitalItems));
  var allRawItems = [].concat(_toConsumableArray((lineItems === null || lineItems === void 0 ? void 0 : lineItems.physicalItems) || []), _toConsumableArray((lineItems === null || lineItems === void 0 ? void 0 : lineItems.digitalItems) || []));
  var wineRawItems = allRawItems.filter(function (item) {
    return item.isSpirit !== true;
  });
  var spiritRawItems = allRawItems.filter(function (item) {
    return item.isSpirit === true;
  });
  var cartComposition = "unknown";
  if (wineRawItems.length > 0 && spiritRawItems.length > 0) {
    cartComposition = "mixed";
  } else if (spiritRawItems.length > 0) {
    cartComposition = "spirits_only";
  } else if (wineRawItems.length > 0) {
    cartComposition = "wine_only";
  }
  var orderData = _objectSpread(_objectSpread(_objectSpread({}, trackedAlgoliaIndexFields(cartComposition === "spirits_only")), {}, {
    eventType: EventType.Conversion,
    eventSubtype: EventSubType.Purchase,
    order_id: orderId
  }, mapAddress(billingAddress)), {}, {
    value: baseAmount,
    revenue: baseAmount,
    shipping: shippingCostTotal,
    tax: taxTotal,
    discount: discountAmount,
    coupon: coupons === null || coupons === void 0 ? void 0 : coupons.join(","),
    currency: (currency === null || currency === void 0 ? void 0 : currency.code) || currency,
    first_purchase: firstOrder,
    is_dealer: isDealer,
    channel: channel,
    agent: agent,
    checkoutMode: checkoutMode,
    products: productList,
    cart_composition: cartComposition,
    payment_method: formatPaymentMethodLabel(paymentMethod),
    shipping_method: shippingMethod,
    cart_id: cartId,
    opt_in: opt_in,
    customer_group: (customerGroup === null || customerGroup === void 0 ? void 0 : customerGroup.name) || "No Group"
  });
  if (typeof window !== "undefined" && window.analytics) {
    if (marketCode === "AU") {
      if (cartComposition === "wine_only") {
        window.analytics.track(eventName, orderData);
      } else if (cartComposition === "spirits_only") {
        window.analytics.track("Whisky Order Completed", _objectSpread(_objectSpread({}, orderData), {}, {
          cart_composition: "spirits_only"
        }));
      } else if (cartComposition === "mixed") {
        var getSubtotal = function getSubtotal(items) {
          return items.reduce(function (acc, item) {
            return acc + (item.extendedSalePrice || 0);
          }, 0);
        };
        var wineRevenue = getSubtotal(wineRawItems);
        var spiritRevenue = getSubtotal(spiritRawItems);
        var wineProducts = _toConsumableArray(wineRawItems).map(function (item) {
          return lineItemToSegmentProduct(item);
        });
        var spiritProducts = _toConsumableArray(spiritRawItems).map(function (item) {
          return lineItemToSegmentProduct(item);
        });
        window.analytics.track(eventName, _objectSpread(_objectSpread({}, orderData), {}, {
          value: wineRevenue,
          revenue: wineRevenue,
          products: wineProducts,
          cart_composition: "wine_only"
        }));
        window.analytics.track("Whisky Order Completed", _objectSpread(_objectSpread(_objectSpread({}, orderData), trackedAlgoliaIndexFields(true)), {}, {
          value: spiritRevenue,
          revenue: spiritRevenue,
          products: spiritProducts,
          cart_composition: "spirits_only"
        }));
      }
    } else {
      window.analytics.track(eventName, orderData);
    }
  }
};
export var trackFirstOrderCompleted = function trackFirstOrderCompleted(eventName, data) {
  var _data$billingAddress, _data$billingAddress2, _data$billingAddress3, _data$billingAddress4, _data$billingAddress5, _data$billingAddress6, _data$billingAddress7, _data$billingAddress8, _data$coupons, _data$customerGroup;
  var paymentMethod = data.paymentMethod,
    shippingMethod = data.shippingMethod,
    lineItems = data.lineItems;
  var allRawItems = [].concat(_toConsumableArray((lineItems === null || lineItems === void 0 ? void 0 : lineItems.physicalItems) || []), _toConsumableArray((lineItems === null || lineItems === void 0 ? void 0 : lineItems.digitalItems) || []));
  var wineRawItems = allRawItems.filter(function (item) {
    return item.isSpirit !== true;
  });
  var spiritRawItems = allRawItems.filter(function (item) {
    return item.isSpirit === true;
  });
  var cartComposition = "unknown";
  if (wineRawItems.length > 0 && spiritRawItems.length > 0) {
    cartComposition = "mixed";
  } else if (spiritRawItems.length > 0) {
    cartComposition = "spirits_only";
  } else if (wineRawItems.length > 0) {
    cartComposition = "wine_only";
  }
  var orderData = {
    order_id: data.orderId,
    firstName: data === null || data === void 0 || (_data$billingAddress = data.billingAddress) === null || _data$billingAddress === void 0 ? void 0 : _data$billingAddress.firstName,
    lastName: data === null || data === void 0 || (_data$billingAddress2 = data.billingAddress) === null || _data$billingAddress2 === void 0 ? void 0 : _data$billingAddress2.lastName,
    email: data === null || data === void 0 || (_data$billingAddress3 = data.billingAddress) === null || _data$billingAddress3 === void 0 ? void 0 : _data$billingAddress3.email,
    phone: toE164Digits(data === null || data === void 0 || (_data$billingAddress4 = data.billingAddress) === null || _data$billingAddress4 === void 0 ? void 0 : _data$billingAddress4.phone) || undefined,
    city: data === null || data === void 0 || (_data$billingAddress5 = data.billingAddress) === null || _data$billingAddress5 === void 0 ? void 0 : _data$billingAddress5.city,
    state: data === null || data === void 0 || (_data$billingAddress6 = data.billingAddress) === null || _data$billingAddress6 === void 0 ? void 0 : _data$billingAddress6.stateOrProvince,
    postalCode: data === null || data === void 0 || (_data$billingAddress7 = data.billingAddress) === null || _data$billingAddress7 === void 0 ? void 0 : _data$billingAddress7.postalCode,
    country: data === null || data === void 0 || (_data$billingAddress8 = data.billingAddress) === null || _data$billingAddress8 === void 0 ? void 0 : _data$billingAddress8.country,
    created_at: data.createdAt,
    value: data === null || data === void 0 ? void 0 : data.baseAmount,
    revenue: data === null || data === void 0 ? void 0 : data.baseAmount,
    shipping: data === null || data === void 0 ? void 0 : data.shippingCostTotal,
    tax: data === null || data === void 0 ? void 0 : data.taxTotal,
    discount: data.discountAmount,
    coupon: (_data$coupons = data.coupons) === null || _data$coupons === void 0 ? void 0 : _data$coupons.join(","),
    is_dealer: data === null || data === void 0 ? void 0 : data.isDealer,
    channel: data === null || data === void 0 ? void 0 : data.channel,
    agent: data === null || data === void 0 ? void 0 : data.agent,
    checkoutMode: data === null || data === void 0 ? void 0 : data.checkoutMode,
    cart_composition: cartComposition,
    payment_method: formatPaymentMethodLabel(paymentMethod),
    shipping_method: shippingMethod,
    customer_group: (data === null || data === void 0 || (_data$customerGroup = data.customerGroup) === null || _data$customerGroup === void 0 ? void 0 : _data$customerGroup.name) || "No Group"
  };
  if (typeof window !== "undefined" && window.analytics) {
    if (marketCode === "AU") {
      if (cartComposition === "wine_only") {
        window.analytics.track(eventName, orderData);
      } else if (cartComposition === "mixed") {
        var getSubtotal = function getSubtotal(items) {
          return items.reduce(function (acc, item) {
            return acc + (item.extendedSalePrice || 0);
          }, 0);
        };
        var wineRevenue = getSubtotal(wineRawItems);
        window.analytics.track(eventName, _objectSpread(_objectSpread({}, orderData), {}, {
          value: wineRevenue,
          revenue: wineRevenue,
          cart_composition: "wine_only"
        }));
      }
    } else {
      window.analytics.track(eventName, orderData);
    }
  }
};
export var trackFirstWhiskyOrderCompleted = function trackFirstWhiskyOrderCompleted(data) {
  var _data$billingAddress9, _data$billingAddress0, _data$billingAddress1, _data$billingAddress10, _data$billingAddress11, _data$billingAddress12, _data$billingAddress13, _data$billingAddress14, _data$coupons2, _data$customerGroup2;
  if (marketCode !== "AU") return;
  var paymentMethod = data.paymentMethod,
    shippingMethod = data.shippingMethod,
    lineItems = data.lineItems;
  var allRawItems = [].concat(_toConsumableArray((lineItems === null || lineItems === void 0 ? void 0 : lineItems.physicalItems) || []), _toConsumableArray((lineItems === null || lineItems === void 0 ? void 0 : lineItems.digitalItems) || []));
  var spiritRawItems = allRawItems.filter(function (item) {
    return item.isSpirit === true;
  });
  if (spiritRawItems.length === 0) return;
  var orderData = {
    order_id: data.orderId,
    firstName: data === null || data === void 0 || (_data$billingAddress9 = data.billingAddress) === null || _data$billingAddress9 === void 0 ? void 0 : _data$billingAddress9.firstName,
    lastName: data === null || data === void 0 || (_data$billingAddress0 = data.billingAddress) === null || _data$billingAddress0 === void 0 ? void 0 : _data$billingAddress0.lastName,
    email: data === null || data === void 0 || (_data$billingAddress1 = data.billingAddress) === null || _data$billingAddress1 === void 0 ? void 0 : _data$billingAddress1.email,
    phone: toE164Digits(data === null || data === void 0 || (_data$billingAddress10 = data.billingAddress) === null || _data$billingAddress10 === void 0 ? void 0 : _data$billingAddress10.phone) || undefined,
    city: data === null || data === void 0 || (_data$billingAddress11 = data.billingAddress) === null || _data$billingAddress11 === void 0 ? void 0 : _data$billingAddress11.city,
    state: data === null || data === void 0 || (_data$billingAddress12 = data.billingAddress) === null || _data$billingAddress12 === void 0 ? void 0 : _data$billingAddress12.stateOrProvince,
    postalCode: data === null || data === void 0 || (_data$billingAddress13 = data.billingAddress) === null || _data$billingAddress13 === void 0 ? void 0 : _data$billingAddress13.postalCode,
    country: data === null || data === void 0 || (_data$billingAddress14 = data.billingAddress) === null || _data$billingAddress14 === void 0 ? void 0 : _data$billingAddress14.country,
    created_at: data.createdAt,
    value: data === null || data === void 0 ? void 0 : data.baseAmount,
    revenue: data === null || data === void 0 ? void 0 : data.baseAmount,
    shipping: data === null || data === void 0 ? void 0 : data.shippingCostTotal,
    tax: data === null || data === void 0 ? void 0 : data.taxTotal,
    discount: data.discountAmount,
    coupon: (_data$coupons2 = data.coupons) === null || _data$coupons2 === void 0 ? void 0 : _data$coupons2.join(","),
    is_dealer: data === null || data === void 0 ? void 0 : data.isDealer,
    channel: data === null || data === void 0 ? void 0 : data.channel,
    agent: data === null || data === void 0 ? void 0 : data.agent,
    checkoutMode: data === null || data === void 0 ? void 0 : data.checkoutMode,
    payment_method: formatPaymentMethodLabel(paymentMethod),
    shipping_method: shippingMethod,
    customer_group: (data === null || data === void 0 || (_data$customerGroup2 = data.customerGroup) === null || _data$customerGroup2 === void 0 ? void 0 : _data$customerGroup2.name) || "No Group"
  };
  var getSubtotal = function getSubtotal(items) {
    return items.reduce(function (acc, item) {
      return acc + (item.extendedSalePrice || 0);
    }, 0);
  };
  var spiritRevenue = getSubtotal(spiritRawItems);
  if (typeof window !== "undefined" && window.analytics) {
    window.analytics.track("First Whisky Order Completed", _objectSpread(_objectSpread(_objectSpread({}, orderData), trackedAlgoliaIndexFields(true)), {}, {
      value: spiritRevenue,
      revenue: spiritRevenue,
      cart_composition: "spirits_only"
    }));
  }
};
export var trackCouponEntered = function trackCouponEntered(eventName, data, couponCode) {
  var checkout = data === null || data === void 0 ? void 0 : data.getCheckout();
  var couponData = {
    cart_id: checkout.cart.id,
    order_id: checkout.orderId,
    coupon_id: couponCode,
    source: "/checkout"
  };
  if (typeof window !== "undefined" && window.analytics) {
    window.analytics.track(eventName, couponData);
  }
};
export var trackCouponApplied = function trackCouponApplied(eventName, data, couponCode, couponName, discount) {
  var checkout = data === null || data === void 0 ? void 0 : data.getCheckout();
  var couponData = {
    cart_id: checkout.cart.id,
    order_id: checkout.orderId,
    coupon_id: couponCode,
    discount: discount,
    source: "/checkout"
  };
  if (typeof window !== "undefined" && window.analytics) {
    window.analytics.track(eventName, couponData);
  }
};
export var trackCouponDenied = function trackCouponDenied(eventName, data, couponCode, error) {
  var checkout = data === null || data === void 0 ? void 0 : data.getCheckout();
  var couponData = {
    cart_id: checkout.cart.id,
    order_id: checkout.orderId,
    coupon_id: couponCode,
    reason: error
  };
  if (typeof window !== "undefined" && window.analytics) {
    window.analytics.track(eventName, couponData);
  }
};
var lineItemToSegmentProduct = function lineItemToSegmentProduct(lineItem) {
  if (lineItem) {
    var _buildItemProductUrl;
    return {
      offer_id: lineItem === null || lineItem === void 0 ? void 0 : lineItem.offerId,
      product_id: lineItem === null || lineItem === void 0 ? void 0 : lineItem.offerId,
      sku: lineItem === null || lineItem === void 0 ? void 0 : lineItem.sku,
      quantity: lineItem === null || lineItem === void 0 ? void 0 : lineItem.quantity,
      name: lineItem === null || lineItem === void 0 ? void 0 : lineItem.name,
      image_url: lineItem === null || lineItem === void 0 ? void 0 : lineItem.imageUrl,
      price: lineItem === null || lineItem === void 0 ? void 0 : lineItem.salePrice,
      brand: lineItem === null || lineItem === void 0 ? void 0 : lineItem.brand,
      category: lineItem === null || lineItem === void 0 ? void 0 : lineItem.category,
      discount: lineItem === null || lineItem === void 0 ? void 0 : lineItem.discountAmount,
      inventoryStatus: lineItem === null || lineItem === void 0 ? void 0 : lineItem.inventoryStatus,
      url: (_buildItemProductUrl = buildItemProductUrl(lineItem, getStorefrontHostForItem(lineItem))) !== null && _buildItemProductUrl !== void 0 ? _buildItemProductUrl : undefined,
      market: process.env.VM_MARKET || "AU",
      mixed: lineItem === null || lineItem === void 0 ? void 0 : lineItem.mixed,
      pack_size: lineItem === null || lineItem === void 0 ? void 0 : lineItem.pack_size,
      preservatives: lineItem === null || lineItem === void 0 ? void 0 : lineItem.preservatives,
      region: lineItem === null || lineItem === void 0 ? void 0 : lineItem.region,
      rrp: lineItem === null || lineItem === void 0 ? void 0 : lineItem.rrp,
      style: lineItem === null || lineItem === void 0 ? void 0 : lineItem.style,
      variant: lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant,
      varietal: lineItem === null || lineItem === void 0 ? void 0 : lineItem.varietal,
      vintage: lineItem === null || lineItem === void 0 ? void 0 : lineItem.vintage
    };
  }
};
export var trackCreateAnAccountClicked = function trackCreateAnAccountClicked(eventName, data) {
  var analyticData = {
    cart_id: data.cartId,
    order_id: data.orderId
  };
  if (typeof window !== "undefined" && window.analytics) {
    window.analytics.track(eventName, analyticData);
  }
};
export var trackEvent = function trackEvent(eventName, events) {
  if (typeof window !== "undefined" && typeof window.analytics !== "undefined") {
    window.analytics.track(eventName, events);
  }
};